import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { th } from './languages/th'
import { en } from './languages/en'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ELanguage } from './languages/types'

export const i18nResources = {
  [ELanguage.Thai]: {
    translation: th
  },
  [ELanguage.English]: {
    translation: en
  }
}

export const useChangeLanguage = () => {
  const queryClient = useQueryClient()
  return useMutation(async () => {
    queryClient.invalidateQueries([])
  })
}

export const defaultNS = 'translation'

export const changeLanguage = async (str: string) => {
  return await i18next.changeLanguage(str)
}

i18next
  .use(initReactI18next)
  .init({
    defaultNS,
    lng: ELanguage.English,
    fallbackLng: ELanguage.English,
    resources: i18nResources,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })
  .catch(() => undefined)

export default i18next
